import * as actionTypes from './../Global_action.types';
import * as api from './../global_api_services/Client_and_unit_wise_holidays.api';


export const getClient_unit_wise_holidaysRequest = () => ({
  type: actionTypes.GET_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST,
});

export const getClient_unit_wise_holidaysSuccess = (client_unit_holidays) => ({
  type: actionTypes.GET_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS,
  payload: client_unit_holidays,
});

export const getClient_unit_wise_holidaysFailure = (error) => ({
  type: actionTypes.GET_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE,
  payload: error,
});

export const getClient_unit_wise_holidays = () => {
  return async (dispatch) => {
    dispatch(getClient_unit_wise_holidaysRequest());
    try {
      const client_unit_holiday = await api.fetchClient_unit_wise_holidaysData();
      dispatch(getClient_unit_wise_holidaysSuccess(client_unit_holiday));
      return { success: true, data: client_unit_holiday };
    } catch (error) {
      dispatch(getClient_unit_wise_holidaysFailure(error));
      return { success: false, message: error };
    }
  };
};

export const updateClient_unit_wise_holidaysRequest = (id, maternityData) => ({
  type: actionTypes.UPDATE_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST,
  payload: { id, maternityData },
});

export const updateClient_unit_wise_holidaysSuccess = (message) => ({
  type: actionTypes.UPDATE_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS,
  payload: message,
});

export const updateClient_unit_wise_holidaysFailure = (error) => ({
  type: actionTypes.UPDATE_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE,
  payload: error,
});

export const updateClient_unit_wise_holidaysById = (id, contractorData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    contractorData.updated_by = user.user_name;

    dispatch(updateClient_unit_wise_holidaysRequest(id, contractorData));
    try {
      const response = await api.update_client_and_unit_wise_holiday(id, contractorData);
      dispatch(updateClient_unit_wise_holidaysSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateClient_unit_wise_holidaysFailure(error));
      return { success: false, message: error };
    }
  };
};


export const deleteClient_unit_wise_holidaysRequest = (id) => ({
  type: actionTypes.DELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST,
  payload: id,
});

export const deleteClient_unit_wise_holidaysSuccess = (message) => ({
  type: actionTypes.DELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS,
  payload: message,
});

export const deleteClient_unit_wise_holidaysFailure = (error) => ({
  type: actionTypes.DELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE,
  payload: error,
});

export const deleteClient_unit_wise_holidaysById = (id,deleteData) => {
  return async (dispatch) => {
    dispatch(deleteClient_unit_wise_holidaysRequest(id,deleteData));
    try {
      const response = await api.deleteClient_unit_wise_holidays(id,deleteData);
      dispatch(deleteClient_unit_wise_holidaysSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteClient_unit_wise_holidaysFailure(error));
      return { success: false, message: error };
    }
  };
};



export const uploadClient_unit_wise_holidaysRequest = (fileData) => ({
  type: actionTypes.UPLOAD_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST,
  payload: fileData,
});

export const uploadClient_unit_wise_holidaysSuccess = (message) => ({
  type: actionTypes.UPLOAD_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS,
  payload: message,
});

export const uploadClient_unit_wise_holidaysFailure = (error) => ({
  type: actionTypes.UPLOAD_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE,
  payload: error,
});

export const uploadClient_unit_wise_holidaysFile = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadClient_unit_wise_holidaysRequest(fileData));
    try {
      const response = await api.Client_unit_wise_holidaysUpload(fileData);
      console.log("error cu 1 ",response);
      dispatch(uploadClient_unit_wise_holidaysSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      console.log("error cu" ,error);

      dispatch(uploadClient_unit_wise_holidaysFailure(error));
      const errorMessage = error?.response?.data?.error || error?.message || 'Upload failed';
      return { success: false, error: errorMessage };
    }
  };
};

export const multiDaleteClient_unit_wise_holidaysRequest = (ids) => ({
  type: actionTypes.MULTIDELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST,
  payload: ids,
});

export const multiDaleteClient_unit_wise_holidaysSuccess = (message) => ({
  type: actionTypes.MULTIDELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS,
  payload: message,
});

export const multiDaleteClient_unit_wise_holidaysFailure = (error) => ({
  type: actionTypes.MULTIDELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE,
  payload: error,
});

export const multiDeleteClient_unit_wise_holidaysapi = (ids) => {
  return async (dispatch) => {
    dispatch(multiDaleteClient_unit_wise_holidaysRequest(ids));
    try {
      const response = await api.multiDeleteClient_unit_wise_holidays(ids);
      dispatch(multiDaleteClient_unit_wise_holidaysSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaleteClient_unit_wise_holidaysFailure(error));
      return { success: false, message: error };
    }
  };
};


